export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-pause-3a9e373d553357aa969a36842119dd8e.svg";